module.exports = __webpack_public_path__ + "assets/images/CNY10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CNY10.png
// module id = 1343
// module chunks = 1